//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { NoticeBar } from 'vant'
import CBottomButtons from '../../CBottomButtons'
import { SAVE_SUCCESS } from '../../../constant/tips'
import { toast } from '../../../utils/toast.js'

export default {
  name: 'TAddGraduationSchool',

  components: {
    NoticeBar,
    CBottomButtons,
  },

  props: {
    saveMethod: { type: Function },

    postMethod: { type: Function },

    formComponent: { type: Object },

    methodConfig: {
      type: Object,
      default: () => ({}),
    },

  },

  data () {
    return {
      formData: {},
      bottomButtons: [
        {
          title: '返回',
          key: 'back',
          class: 'back',
          handler: () => {
            this.doBack()
          },
        },
        {
          title: '保存',
          key: 'add',
          class: 'add',
          handler: () => {
            this.doAdd()
          },
        },
      ],
    }
  },

  methods: {
    doBack () {
      this.$emit('on-return')
    },

    async doAdd () {
      const res = await this.$refs.formDom.validate()

      if (!res) {
        return
      }

      const data = await this.saveMethod(this.formData, this.httpConfig, this.postMethod)

      if (data.code === 0) {
        toast(data.msg || SAVE_SUCCESS)
        this.doBack()
        this.$emit('reload')
      }
    },
  },
}
